module.exports = __webpack_public_path__ + "img/全局美颜--自由调节.e2f6e0dd.png";